import { decode } from "../queryEncryption";
import { censorWord, censorEmail } from "../secureEmail";
const base64regex = /^[A-Za-z0-9+/=]+$/;

const getValue = (value) => {
    try {
        return base64regex?.test(value) ? decode(value) : value;
    } catch (error) {
        return value;
    }
};

export const getFormData = (value) => {
    return {
        id: value?.id,
        smtpName: value?.smtpName,
        smtpHost: getValue(value?.smtpHost),
        smtpPort: getValue(value?.smtpPort),
        smtpEmail: getValue(value?.smtpEmail),
        smtpSender: getValue(value?.smtpSender),
        smtpSenderEmail: getValue(value?.smtpSenderEmail),
        smtpPassword: getValue(value?.smtpPassword),
        isActive: value?.isActive
    };
};

export const getCensorFormData = (value, isEncrypt) => {
    return {
        id: value?.id,
        smtpName: isEncrypt ? censorWord(value?.smtpName) : value?.smtpName,
        smtpHost: isEncrypt ? censorWord(getValue(value?.smtpHost)) : getValue(value?.smtpHost),
        smtpPort: isEncrypt ? censorWord(getValue(value?.smtpPort)) : getValue(value?.smtpPort),
        smtpEmail: isEncrypt ? censorEmail(getValue(value?.smtpEmail)) : getValue(value?.smtpEmail),
        smtpSender: isEncrypt ? censorWord(getValue(value?.smtpSender)) : getValue(value?.smtpSender),
        smtpSenderEmail: isEncrypt ? censorEmail(getValue(value?.smtpSenderEmail)) : getValue(value?.smtpSenderEmail),
        smtpPassword: isEncrypt ? censorWord(getValue(value?.smtpPassword)) : getValue(value?.smtpPassword),
        isActive: value?.isActive,
        isEncrypt
    };
};